<section class="dashboard-bookings__section">
	<div class="panel__header h4" data-cy="dashboard-bookings__header">{{ 'dashboard.bookings_header' | locale: merchantLocaleSuffix }}</div>
	<div class="panel__wrapper">
		<div class="panel__title h5">Example Booking Product</div>
		<div class="panel__info-row">
			<div class="info-row__column" data-cy="dashboard-bookings__booking-icon">
				<img class="info-row__image" src="/assets/billing/creditcard.svg" alt="booking-icon"/>
			</div>
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-bookings__order-id-label">{{ 'dashboard.order_id' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-bookings__order-id-value">987654</div>
			</div>
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-bookings__purchase-date-label">{{ 'dashboard.purchase_date' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-bookings__purchase-date-value">Jan 1, 2025</div>
			</div>
			<div class="info-row__column">
				<div class="info-row__label mat-subtitle-2" data-cy="dashboard-bookings__quantity-label">{{ 'dashboard.quantity' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__value mat-subtitle-1" data-cy="dashboard-bookings__quantity-value">9</div>
			</div>
		</div>
	</div>
</section>
